import React, { FC } from 'react';
import styled from 'styled-components';
import { LandingPageHeader, LandingPageLayout } from 'src/components/widgets/layouts';
import { SkeletonBlock, SkeletonStack } from 'src/components/widgets/skeleton';

const LandingSkeletonCards = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 25px;
    padding: 80px 0;

    @media (min-width: 768px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
`;

export const LandingPageSkeleton: FC = () => (
    <div aria-hidden='true'>
        <LandingPageHeader>
            <SkeletonStack $gap='18px' $align='center' $width='100%'>
                <SkeletonBlock $width='min(540px, 100%)' $height='38px' />
                <SkeletonBlock $width='min(680px, 100%)' $height='48px' />
                <SkeletonBlock $width='130px' $height='38px' $radius='6px' />
                <SkeletonBlock $width='min(640px, 100%)' $height='220px' $margin='32px 0 0' />
            </SkeletonStack>
        </LandingPageHeader>
        <LandingPageLayout>
            <LandingSkeletonCards>
                {[0, 1, 2].map((index) => (
                    <SkeletonBlock key={index} $height='190px' $radius='8px' />
                ))}
            </LandingSkeletonCards>
        </LandingPageLayout>
    </div>
);
